import React, { Component } from 'react';

const withError = (WrappedComponent, errorType) => {
   return class extends Component {
      render() {
        return <WrappedComponent {...this.props} errorType={errorType} />
      }

  }
}

export default withError;



// WEBPACK FOOTER //
// ./src/components/error/withError.js